import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { WFWorker } from 'src/app/store/events.era';
import { ManageWorkersComponent } from 'src/app/components/manage-workers/manage-workers.component';
import { PermissionAccess } from 'src/app/store/permissions.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { newWorkerStages, WorkforceActions } from 'src/app/store/workforce.era';

@Component({
    selector: 'invite-dialog',
    template: `
<div class="joi-dialog with-manage-workers">
  <div mat-dialog-content>
    <div class="loading" *ngIf="!loaded"><div class="message">Loading...</div></div>
    <app-manage-workers *ngIf="!!loaded" #manageWorkers [no_animate]="!!data" [existing]="isInviting"></app-manage-workers>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="close()">CANCEL</button>
    <div style="flex:1;"></div>
    <ng-container *ngIf="!!loaded && { hasContacts: !!manageWorkers?.selectedContacts?.size, onEmail: newWorkerStatus === newWorkerStages.email_address } as vars">
      <button class="no_margin" mat-button *ngIf="(vars.onEmail || vars.hasContacts) && !isInviting"
          [disabled]="(!vars.hasContacts && !manageWorkers?.isValid) || workforceService.errorMessage !== null"
          (click)="vars.hasContacts ? addSelectedInvitesLater() : addInviteLater()
          ">ADD & INVITE LATER</button>
      <button mat-button color="primary" *ngIf="(vars.onEmail || vars.hasContacts) && !isInviting"
        [disabled]="(!vars.hasContacts && !manageWorkers?.isValid) || workforceService.errorMessage !== null"
          (click)="continue()">CONTINUE</button>
      <button *ngIf="isInviting"
        mat-button color="primary"
        (click)="(vars.hasContacts ? sendSelectedInvites() : sendInvite())"
        [disabled]="!workforceService.invite_valid">SEND</button>
    </ng-container>
  </div>
</div>
`,
    styles: [`
  .loading { display: flex; min-height: 311px; min-width: 400px; flex-direction: row; align-items: center; }
  .loading .message { margin: auto; }
  `],
    standalone: true,
    imports: [ManageWorkersComponent, MatButtonModule, CommonModule, MatDialogModule]
})
export class InviteDialogComponent extends Wrapper<InviteDialogComponent> implements OnInit, OnDestroy {

  newWorkerStatus
  newWorkerStages = newWorkerStages
  isInviting = false
  loaded = false
  @ViewChild('manageWorkers') manageWorkers: ManageWorkersComponent;

  constructor(public dialogRef: MatDialogRef<InviteDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InviteDialogData) {
    super()
    if (this.data) { // loading the dialog from the invite button after a worker has been added to the workforce
      const { worker } = this.data
      this.isInviting = true
      // console.log(this.isInviting)
      this.permissionsService.getRestrictionsFor(worker.email).then((permissions:PermissionAccess)=>{
        this.store.dispatch(WorkforceActions.loadNewWorkerAndPermissions({
          newWorker: worker,
          newWorkerPermissions: permissions ? permissions : this.permissionsService.getBlankRestrictionsObject(),
        }))
        this.store.dispatch(WorkforceActions.changeNewWorkerStatus( 'invite_existing' ))
      })
    } else {
      this.store.dispatch(WorkforceActions.changeNewWorkerStatus( 'init' ))
      this.store.dispatch(WorkforceActions.getFreshWorker())
    }
    this.subCallback(this.store.select('workforce','newWorkerStatus'), newWorkerStatus => {
      this.newWorkerStatus = newWorkerStatus
      if (newWorkerStatus) {
        this.loaded = true
        this.isInviting = [newWorkerStages.send_invite as string, newWorkerStages.invite_existing].includes(newWorkerStatus)
      }
    })
    this.workforceService.errorMessage = null;
  }
  ngOnInit() {
  }

  continue() {
    if (this.manageWorkers.selectedContacts.size === 1 || this.manageWorkers.possible_contacts.length === 1) {
      this.store.dispatch(WorkforceActions.updateNewWorker(this.manageWorkers.getSelectedWorkers()[0]))
    }
    this.store.dispatch(WorkforceActions.changeNewWorkerStatus('send_invite'))    
  }

  addSelectedInvitesLater() {
    this.workforceService.addWorkersToWorkforceOnly(this.manageWorkers.getSelectedWorkers())
    this.close();
  }

  addInviteLater() { // for a user added worker
    this.workforceService.addWorkerToWorkforce()
    this.close();
  }

  sendInvite() {
    this.workforceService.inviteWorker()
    this.close();
  }

  sendSelectedInvites() {
    this.workforceService.inviteWorkers(this.manageWorkers.getSelectedWorkers())
    this.close();
  }


  close() {
      this.dialogRef.close();
  }
  ngOnDestroy() {
      this.workforceService.resetInviteVariables();
  }
}

export interface InviteDialogData {
  worker?: WFWorker
}
